import { IParkingLotTitleProps } from "./props";
import "./parking-lot-title.scss";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function ParkingLotTitle(props: IParkingLotTitleProps)
{
    return (
        <div className="parking-lot-title-container">
            {props.title}
        </div>
    );
}
